import React from "react";
import { GlobalContext } from "../../../../../utils/globalprovider";
import ToolsBar from "../../../../../components/bases/toolsbar/toolsbar";

// correction des intervalles
import SubtitleCloseGap from "./subtitleintervalcomponents/subtitleclosegap";
import SubtitleNearMinimumGap from "./subtitleintervalcomponents/subtitlenearminimungap";
import SubtitleSceneChanges from "./subtitleintervalcomponents/subtitlescenechanges";

import SubtitleSelectionMode from "./SubtitleRange/subtitleselectionmode";


import imgexit from "./assets/exit.png"
import imgaccept from "./assets/accept.png"

import "./submenus.css"


class SubtitleInterval extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props);
        this.state =
        {
            toolsbar : {
                height: 26,
                items: [
                    {img: imgexit ,type:"button", disable:false,fr:"Fermer",en:"Close", nochangecolor:false, key:{key:"EXIT", cat:"actions"}},
                    {type:"space"},
                    {img: imgaccept ,type:"button", disable:false,fr:"Lancer",en:"Start", nochangecolor:false, key:{key:"START", cat:"actions"}},


                    ],
            },

        }

        this.state.parameters = this.setStateValue();

        this.selectionModeRef = React.createRef();
        this.onClickToolsBar = this.onClickToolsBar.bind(this);
    }




    onClickToolsBar(datas)
    {
        switch (datas.key)
        {
            case "START":
                if (this.props.onaction) 
                {
                    const ret = {
                        source: "parameters",
                        action:
                        {
                            
                            type: "interval",
                            parameters: this.state.parameters,
                            range: this.selectionModeRef.current.getValues(),
                        }
                    };

                    console.log("retour", ret);
                    if (this.props.onaction) this.props.onaction (ret);
                }

                
                break;


            case "EXIT":
                if (this.props.onaction) this.props.onaction ({source:"submenu", submenu: {key:"EXIT"}});
                break;
        }
    }

    setStateValue()
    {
        return {
            section1: {
                enabled: true,
                method: 2,
                value: this.props.stparams.i_interst,
            },
            section2: {
                enabled: false,
                value: this.props.stparams.i_interst+2,
                ignoreSceneChanges: false,

            },
            section3: {
                in:{
                    enabled: false,
                    value: this.props.stparams.i_aftercp,
                    nearEnabled: false,
                    nearValue: this.props.stparams.i_aftercp+2


                },
                out:{
                    enabled: false,
                    value: this.props.stparams.i_beforecp,
                    nearEnabled: false,
                    nearValue: this.props.stparams.i_beforecp+2

                }
            }
        }


    }
    componentDidUpdate(prevProps)
    {   
        
        if (JSON.stringify(prevProps.stparams) != JSON.stringify(this.props.stparams))
        {
            console.log("new params : ",this.props.stparams)
            this.setState ({parameters: this.setStateValue()})
        }
    }

    render()
    {
        const title = this.context.language=="fr"?"Correction des intervalles":"Interval correction";
                return (
                    <div className="submenuMain">
                            <div className="submenuTitle">{title}</div>

                            <div className="submenuCurrentDiv">
                                <SubtitleCloseGap
                                    enabled={this.state.parameters.section1.enabled}
                                    method={this.state.parameters.section1.method}
                                    value={this.state.parameters.section1.value}
                                    onChange={
                                        (params) => {
                                            console.log(params);
                                            this.state.parameters.section1.enabled= params.enabled;
                                            this.state.parameters.section1.value= params.value;
                                            this.state.parameters.section1.method= params.method;
                                        }
                                    }
                                    

                                />
                                <SubtitleNearMinimumGap
                                    enabled={this.state.parameters.section2.enabled}
                                    value={this.state.parameters.section2.value}
                                    ignoreSceneChanges={this.state.parameters.section2.ignoreSceneChanges}
                                    onChange={
                                        (params) => {
                                            console.log(params);
                                            this.state.parameters.section2.enabled= params.enabled;
                                            this.state.parameters.section2.value= params.value;
                                            this.state.parameters.section2.ignoreSceneChanges= params.ignoreSceneChanges;
                                        }
                                    }
                                />                                

                                <SubtitleSceneChanges
                                    inEnabled={this.state.parameters.section3.in.enabled}
                                    inValue={this.state.parameters.section3.in.value}
                                    inNearEnabled={this.state.parameters.section3.in.nearEnabled}
                                    inNearValue={this.state.parameters.section3.in.nearValue}
                                    outEnabled={this.state.parameters.section3.out.enabled}
                                    outValue={this.state.parameters.section3.out.value}
                                    outNearEnabled={this.state.parameters.section3.out.nearEnabled}
                                    outNearValue={this.state.parameters.section3.out.nearValue}
                                    onChange={
                                        (params) => {
                                            console.log(params);
                                            this.state.parameters.section3.in.enabled= params.inEnabled;
                                            this.state.parameters.section3.in.value= params.inValue;
                                            this.state.parameters.section3.in.nearEnabled= params.inNearEnabled;
                                            this.state.parameters.section3.in.nearValue= params.inNearValue;

                                            this.state.parameters.section3.out.enabled= params.outEnabled;
                                            this.state.parameters.section3.out.value= params.outValue;
                                            this.state.parameters.section3.out.nearEnabled= params.outNearEnabled;
                                            this.state.parameters.section3.out.nearValue= params.outNearValue;


                                        }
                                    }
                                />                                

                                <SubtitleSelectionMode ref = {this.selectionModeRef}
                                    value="range"
                                    onChange={(value) => console.log(value)}

                                    subtitles = {this.props.subtitles} 
                                    current = {this.props.current}
                                />                                
                            </div>
                            <div className="submenuBottom">
                            <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar} background={false}/>
                        </div>
                    
                    </div>
                )

    }

}

SubtitleInterval.defaultProps = 
{
    subtitles:[],
    current:1,
}

export default SubtitleInterval;



